import { jsx as _jsx } from "react/jsx-runtime";
import { BackToSection } from "../../../button";
import { StyledNavHistory } from "./NavHistory.styles";
export function NavHistory({ navHistory, onBack, onChange, homeLabel, backLabel, }) {
    function renderBackButton() {
        if (navHistory.length === 2) {
            return (_jsx(BackToSection, { alignByContent: "left", onClick: (e) => {
                    e.preventDefault();
                    onBack();
                }, text: homeLabel, href: "/" }));
        }
        if (navHistory.length >= 4) {
            return (_jsx(BackToSection, { alignByContent: "left", onClick: (e) => {
                    e.preventDefault();
                    onBack();
                }, text: backLabel, href: buildLink(navHistory.slice(0, -1)) }));
        }
        return (_jsx("div", { children: [...navHistory].map((e, index) => {
                var _a;
                if (!e)
                    return null;
                let { title } = e;
                if (!title)
                    return null;
                if (index === 1) {
                    title = homeLabel;
                }
                else {
                    if (!((_a = navHistory[index - 1]) === null || _a === void 0 ? void 0 : _a.title))
                        return null;
                    title = navHistory[index - 1].title;
                }
                return (_jsx(BackToSection, { alignByContent: "left", onClick: (event) => {
                        event.preventDefault();
                        onChange(Object.assign(Object.assign({}, e), { level: e.level }));
                    }, text: title, href: navHistory.at(index - 1).title || "/" }, index));
            }) }));
        function buildLink(navHistory) {
            return navHistory.reduce((acc, cur) => acc.concat(cur.title).concat("/"), "");
        }
    }
    return _jsx(StyledNavHistory, { children: renderBackButton() });
}
